<div class="main">
  <div class="d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column">
    <div style="flex:1;font-size: 18px;">
      To complete your service request,<br>
      please select 2 contractors in order of preference.
    </div>
  </div>
  <br>
    <div class="searchbar">
      <div  class="custom-input-container">
        <div class="search-button"
          (click)="applyFilter()">
        </div>
        <input type="text"
          class="custom-input"
          maxlength="20"
          name="searchQuery"
          placeholder="Search contractor"
          [(ngModel)]="searchQuery"
          (keydown.enter)="applyFilter()">
          @if (searchQuery.length > 0 ) {
            <div
              class="clear-search-button"
              (click)="searchQuery = '' ; applyFilter() ">
            </div>
          }
        </div>
        <button class="button button-default" (click)="modal_filter = true;">
          <img src="assets/img/icons/filter_default.svg"
            alt="filter-icon"
            style="width: 20px ; height: 20px; margin-right: 10px;">
            Filter
          </button>
          @if (modal_filter) {
            <div class="filter-container" (mouseleave)="modal_filter = false;">
              <div class="filter-title">Filter By</div>
              <div>
                <label>Star Rating</label>
                <select-cbm-stars [selectedIndex]="ratingIndex"
                  (onSelectionChanged)="onRatingChanged($event)"
                  (onIndexSelectionChanged)="ratingIndex = $event">
                </select-cbm-stars>
              </div>
              <div>
                <label>PCAB Category</label>
                <select-cbm-pcab [selectedIndex]="pcabCategoryIndex"
                  (onSelectionChanged)="onPcabChanged($event)"
                  (onIndexSelectionChanged)="pcabCategoryIndex">
                </select-cbm-pcab>
              </div>
              <br>
                <button class="button button-active"   (click)="applyFilter()">Apply Filter</button>
                <button class="button button-default"  (click)="clearFilters()">Clear Filter</button>
              </div>
            }
          </div>


          <br>
            <div class="d-flex flex-row align-items-center cbm-header">
              <div style="flex: 3;" class="d-flex flex-row align-items-center">
                Contractor Name
                <button class="cbm-btn desktop-hidden" disabled>
                  <span class="tooltiptext">
                    <span class="tooltiptext-title">PCAB Category</span>
                    <br>
                      Classification set by The Philippine Contractors Accreditation Board (PCAB)
                      based on their independent assessment of the contractor’s credentials,
                      expertise, capitalization and other requirements.
                      <br>
                        <br>
                          <span class="tooltiptext-title">Star Rating</span>
                          <br>
                            Rating is based on the average scores provided by customers who have availed of the contractor’s services.
                          </span>
                          <img src="assets/img/icons/PCAB Tooltip.svg" alt="tooltip-icon">
                        </button>
                      </div>
                      <div style="flex: 1;" class="d-flex flex-row align-items-center mobile-hidden">PCAB Category
                        <button class="pcab-btn" disabled>
                          <span class="tooltiptext">Classification set by The Philippine Contractors Accreditation Board (PCAB) based on their independent assessment of the contractor’s credentials, expertise, capitalization and other requirements.</span>
                          <img src="assets/img/icons/PCAB Tooltip.svg" alt="tooltip-icon">
                        </button>
                      </div>
                      <div style="flex: 1;" class="d-flex flex-row align-items-center mobile-hidden">Star Rating
                        <button class="rating-btn" disabled>
                          <span class="tooltiptext">Rating is based on the average scores provided by customers who have availed of the contractor's services.</span>
                          <img src="assets/img/icons/PCAB Tooltip.svg" alt="tooltip-icon">
                        </button>
                      </div>
                    </div>
                    <div class="d-flex flex-column cbm-list">
                      @for (cbm of cbmList; track cbm; let i = $index) {
                        <cbm-item
                          (itemClick)="onCbmSelected(cbm['uuid'])"
                          [selected]=" isSelected(cbm['uuid']) "
                          [selectionOrder]="getSelectionOrder(cbm['uuid'])"
                          (onViewDetail)="viewDetail(i)"
                          [name]="cbm['cbmName']"
                          [tags]="cbm['tags']"
                          [rating]="cbm['rating']"
                          [cmbId]="cbm['uuid']"
                          [pcab]="cbm['pcabCategory']"
                          [recommended]=" cbm.hasOwnProperty('recommended') ">
                        </cbm-item>
                      }
                    </div>
                    @if ( cbmList.length == 0 && !showProgress) {
                      <div class="no-result">
                        <br>
                          Sorry, contractor not found.<br>Please try again.
                        </div>
                      }
                      @if (showProgress) {
                        <div class="d-flex flex-row align-items-center justify-content-center">
                          <div class="loadingio-spinner-pulse-uq8kufhdmv">
                            <div class="ldio-okxz8jkbhq">
                              <div></div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      }
                      <br>
                        @if (showMore) {
                          <div class="show-more"
                            (click)="onShowMore()">
                            Show more contractors
                          </div>
                        }
                        @if (showPagination) {
                          <pagination-customer
                            [pageCount]="pageCount"
                            [selectedPage]="page"
                            [offset]="pageOffset"
                            (onPageSelected)="showPage($event)">
                          </pagination-customer>
                        }
                        <cbm-detail-modal
                          [visible]="showDetailModal"
                          (onDismiss)="showDetailModal = false;"
                          (onSelect)="onCbmViewSelected($event)"
                          [cbmID]="cbmViewId"
                          [cbmData]="cbmViewData"
                          (onViewAll)="viewCbmPage($event)">
                        </cbm-detail-modal>
                        <info-modal
                          [visible]="modal_info"
                          [title]="'Exceeded the number of\ncontractors selected'"
                          [message]="'You are only allowed to choose 2 contractors.\nPlease unselect a previous choice before choosing a new one. '"
                          (onConfirm)="modal_info = false;">
                        </info-modal>
                      </div>
